import { accessRole } from '../../../../../helpers/access_role'
import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend
} from "reactstrap"
import { ConfirmAlert } from '../../../../../helpers/ui/alert'
import Select from '../../../../../helpers/ui/CustomSelect'
import { AvForm, AvField } from "availity-reactstrap-validation"

import { Link, Redirect } from "react-router-dom"

import apiResponse from '../../../../../services/apiResponse'
import DatePicker from '../../../../../helpers/ui/DatePicker'

import CreateBloc from './Blocs/CreateBloc'
import IndexBloc from '../Index/Blocs/IndexBloc'

class IndexView extends Component {

    createBloc = new CreateBloc();
    indexBloc = new IndexBloc();
    timer

    constructor(props) {
        super(props)
        this.state = {
            dataForm: {},
            criteriaListOption:null,
            componentListOption:null,
        }
    }


    submitData = async () => {
        await this.createBloc.fetchCreate(this.state.dataForm)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
              ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }

    componentDidMount() {
        this.createBloc.fetchCriteriaList()
        this.createBloc.createChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })   
        this.createBloc.criteriaListChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        criteriaListOption: result.data?.response?.result?.filter((item)=> item.assessment_component_type === 1),
                        componentListOption: result.data?.response?.result?.filter((item)=> item.assessment_component_type === 2)
                    });
                    break
                case apiResponse.ERROR:
                    break
                default:
                    break
            }
        })     
    }

    componentWillUnmount() {
        this.createBloc.createChannel?.unsubscribe()
        this.createBloc.criteriaListChannel?.unsubscribe()
    }

    render() {
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <Card>
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`/master/komponen_penilaian_bobot_penilaian_individu.html`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Tambah Bobot Penilaian Individu</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        {/* <Row className="mb-3">
                                            <label className="col-md-3 col-form-label" >
                                                Kriteria Penilaian <span className="text-danger">*</span>
                                            </label>
                                            <Col>
                                                <Select
                                                    name="individual_assessment_criteria_parent_component_uuid"
                                                    placeholder="Kriteria Penilaian..."
                                                    errorMessage="Kriteria Penilaian"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    onChange={(opt) => {
                                                        this.setState({
                                                             criteriaUUID: opt.assessment_component_uuid,
                                                             selectedComponent: null
                                                        })
                                                    }}
                                                    options={this.state.criteriaListOption}
                                                    optionLabel="assessment_component_name"
                                                    optionValue="assessment_component_uuid"
                                                    isLoading={!this.state.criteriaListOption?.length}
                                                />
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label
                                                htmlFor="individual_assessment_criteria_type"
                                                className="col-md-3 col-form-label"
                                            >
                                                Komponen Penilaian <span className="text-danger">*</span>
                                            </label>
                                            <Col>
                                                <Select
                                                    name="individual_assessment_criteria_component_uuid"
                                                    placeholder="Pilih Komponen Penilaian..."
                                                    errorMessage="Pilih Komponen Penilaian"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    onChange={(opt) => this.setState({ selectedComponent: opt })}
                                                    defaultValue={this.state.selectedComponent?.assessment_component_uuid}
                                                    options={this.state.componentListOption?.filter((item) => item.assessment_component_parent_uuid === this.state.criteriaUUID)}
                                                    optionLabel="assessment_component_name"
                                                    optionValue="assessment_component_uuid"
                                                    isLoading={!this.state.componentListOption?.length}
                                                />
                                            </Col>
                                        </Row> */}
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label" >
                                                Nama Bobot <span className="text-danger">*</span>
                                            </label>
                                            <Col>
                                                <AvField
                                                    name="individual_assessment_criteria_name"
                                                    placeholder="Nama Bobot..."
                                                    type="text"
                                                    errorMessage="Masukkan Nama Bobot"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="individual_assessment_criteria_name"
                                                /> 
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label" >
                                                Nilai Bobot <span className="text-danger">*</span>
                                            </label>
                                            <Col>
                                                <AvField
                                                    name="individual_assessment_criteria_value"
                                                    placeholder="Nilai Bobot..."
                                                    type="text"
                                                    errorMessage="Masukkan Nilai Bobot"
                                                    className="form-control"
                                                    validate={{ required: { value: true } }}
                                                    id="individual_assessment_criteria_value"
                                                /> 
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label" >
                                                Berlaku Dari <span className="text-danger">*</span>
                                            </label>
                                            <Col>
                                                <div className="customDatePickerWidth">
                                                    <DatePicker 
                                                        name="individual_assessment_criteria_start_date"
                                                        id="individual_assessment_criteria_start_date"
                                                        placeholder="Tanggal Mulai berlaku..."
                                                        errorMessage="Masukkan Tanggal Mulai berlaku"
                                                        isWeekday={true}
                                                        dateFormat="dd/MM/yyyy"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                        <Row className="mb-3">
                                            <label className="col-md-3 col-form-label">
                                                Berlaku Sampai <span className="text-danger">*</span>
                                            </label>
                                            <Col>
                                                <div className="customDatePickerWidth">
                                                    <DatePicker 
                                                        name="individual_assessment_criteria_end_date"
                                                        id="individual_assessment_criteria_end_date"
                                                        placeholder="Tanggal selesai berlaku..."
                                                        errorMessage="Masukkan Tanggal selesai berlaku"
                                                        isWeekday={true}
                                                        dateFormat="dd/MM/yyyy"
                                                        validate={{ required: { value: true } }}
                                                    />
                                                </div>
                                            </Col>
                                        </Row>

                                       <Row className="mb-3">
                                            <Col></Col>
                                            <Col md="9">
                                                <Link to="?">
                                                    <Button color="danger"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>
                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/master/komponen_penilaian_bobot_penilaian_individu.html?'/>
                : null }
            </Fragment>
        )
    }

}

export default IndexView